export const pixlee = {
  initialize: function () {
    pixlee.handleClick();

    // init slider
    SwiperComponents.initSlider('.js-swiper-pixlee', {
      slidesPerView: 'auto',
      slideVisibleClass: 'swiper-slide-visible',
      watchSlidesProgress: true,
      breakpoints: {
        1024: {
          slidesPerView: 6,
          spaceBetween: 15,
          slidesPerGroup: 2
        }
      }
    }, [{
      swiperEvent: 'transitionEnd',
      function: function () {
        if ($(this.el).find('.swiper-slide:nth-last-child(2)').hasClass('swiper-slide-visible')) {
          let currentPage = $('.px-list-elem:last-child').data('pagenumber');

          pixlee.getPixleeDatas(currentPage);
        }
      }
    }]);
  },
  getPixleeDatas: (currentPage) => {
    currentPage++;

    const ajaxParamsPixlee = {
      token: GLOBAL_SCRIPTS.MEDIA_TOKEN,
      univers: GLOBAL_SCRIPTS.UNIVERS,
      market_code: GLOBAL_SCRIPTS.LANGUAGE_CODE,
      language_code: GLOBAL_SCRIPTS.MARKET_CODE,
      code: PRODUCT_SCRIPTS.PRODUCT_CODE,
      page: currentPage,
      per_page: DEVICE.isMobile ? 6 : DEVICE.isTablet ? 10 : 14
    };

    genericAjaxCall({
      ajaxUrl: GLOBAL_SCRIPTS.URL_API_GO_MEDIA + 'pixlee?',
      ajaxParams: ajaxParamsPixlee,
      successCallback: data => {
        if (data && data.status === 'success') {
          let templatePhotoBlock = '';

          $(data.data.data).each((_index, photosData) => {
            const {
              platform_link,
              user_name,
              photos
            } = photosData;
            const {
              square_medium_url
            } = photos;

            let blocPhoto = `
              <a href="${platform_link}" class="px-list-elem swiper-slide" data-pagenumber="${currentPage}">
                <i class="icon icon-photos-clients"></i>
                <img src="${photosData.photos.square_medium_url !== '' ? photosData.photos.square_medium_url : GLOBAL_SCRIPTS.STATIC_VERSION + '/assets/images/default/400x400.jpg' }" />
                <span class="px-nameUser">@${photosData.user_name}</span>
              </a>`;

            templatePhotoBlock += blocPhoto;
          });

          // Add new slides & update slider
          let swiperInstance = document.querySelector('.js-swiper-pixlee').swiper;

          $(templatePhotoBlock).insertAfter('.px-list-elem:last-child');
          swiperInstance.updateSlides();
          swiperInstance.update();
          pixlee.handleClick();
        }
      },
      abortable: true,
      type: 'GET',
      dataType: 'json'
    });
  },
  handleClick: () => {
    $('.px-list-elem').on('click', e => {
      e.preventDefault();

      const pixleeAnchor = $('.js-allMediasViewerGeneric--open[data-anchor="pixlee"]');

      if (pixleeAnchor.length) {
        pixleeAnchor.click();
      } else {
        // Create the anchor element if it doesn't exist and click it
        $('<a>', {
          class: 'js-allMediasViewerGeneric--open',
          'data-anchor': 'pixlee'
        })
          .appendTo('body')[0].click();
      }
    });
  }
};